<template>
  <div class="ec-dashboard">
    <div ref="wrapper"></div>
  </div>
</template>
<script>
  import * as echarts from 'echarts'
  import { throttle } from '@/utils'
  export default {
    components: {},
    props: {
      data: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      const { achieved, expected } = this.data
      return {
        myChart: null,
        option: {
          series: [
            {
              name: '业务指标',
              type: 'gauge',
              detail: {
                show: false,
              },
              data: [{ value: achieved }],
              startAngle: 180,
              endAngle: 0,
              max: expected,
              axisTick: {
                show: false,
                splitNumber: 2,
                length: 18,
                lineStyle: {
                  color: '#ccc',
                },
              },
              splitNumber: 1,
              axisLine: {
                lineStyle: {
                  width: 18,
                  color: [[1, '#24953d']],
                },
              },
              axisLabel: {
                distance: -10,
                textStyle: {
                  fontSize: 8,
                  color: '#666',
                },
              },
              splitLine: {
                show: false,
              },
              pointer: {
                length: '100%',
                width: 2,
              },
              itemStyle: {
                normal: {
                  color: 'rgb(0, 0, 0)',
                },
              },
              title: {
                show: false,
              },
              radius: '100%',
              animation: false,
            },
          ],
        },
      }
    },
    watch: {
      data: {
        handler() {
          setTimeout(() => {
            this.drawLine()
          }, 50)
        },
        immediate: true,
        deep: true,
      },
    },

    mounted() {
      this.drawLine()
      window.addEventListener('resize', throttle(this.resize, 500))
    },
    unmounted() {
      window.removeEventListener('resize', this.resize)
    },
    methods: {
      drawLine() {
        if (!this.myChart) {
          this.myChart = echarts.init(this.$refs.wrapper)
        }
        let option = { ...this.option }
        const { achieved } = this.data
        var b = achieved / option.series[0].max
        var colorArr = [
          [b, '#e1e1e1'],
          [1, '#24953d'],
        ]
        const elHeight = this.$refs.wrapper.clientHeight
        option.series[0].axisLine.lineStyle.color = colorArr
        option.series[0].axisLine.lineStyle.width = elHeight / 5
        option.series[0].data = [{ value: achieved }]

        this.myChart.setOption(option, true)
      },
      resize() {
        if (!this.$refs.wrapper) return
        echarts.init(this.$refs.wrapper).resize()
        this.drawLine()
      },
    },
  }
</script>
<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .ec-dashboard {
    width: 80px;
    height: 80px;
    margin: 0 auto;
    position: absolute;
    right: 10px;
    top: 10px;
    & > div {
      width: 80px;
      height: 80px;
    }
    &:before {
      content: '';
      display: block;
      width: 3px;
      height: 3px;
      border-radius: 50%;
      background: @black4;
      position: absolute;
      left: 50%;
      top: 8px;
      margin-left: -2.5px;
      z-index: 10;
    }
  }
</style>
